<template lang="pug">
    layout.contentTransparent

        div.mt-1

            // Back button
            back-component.ml-0.pl-0(:route="{name: 'dashboard.statistics.user'}")

        div.journalHeader

            // Title
            title-component(
                :title="$t('journal.list.title')"
                slot="title"
                type="h2"
            )

            div.c-form.mb-3

                date-picker-max.mr-4(
                    label="Filter by Date"
                    :datePickerCallback="datePickerCallback"
                )

                // Note
                note-component(:saveCallback="saveCallback")

        template
            v-layout(row wrap justify-space-between)
                v-flex(xs12)
                    div(v-if="!list.length") {{ $t('journal.list.noItems') }}

                    // Records
                    record-component(v-for="item in list" :key="item.id" :item="item" :showShareButton="showShareButton")
</template>

<script>
    import ButtonBack from '~components/ButtonBack';
    import DatePickerMax from '~components/Picker/DatePicker/DatePickerMax';
    import Note from '~components/Note';
    import Record from '~components/Record';
    import Title from '~components/Title';

    import Layout from '../../Layout/Layout';
    import { mapActions, mapGetters } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import dayjs from 'dayjs';
    import sessions from '~api/sessions';

    export default {
        components: {
            Layout,
            DatePickerMax,
            BackComponent: ButtonBack,
            NoteComponent: Note,
            TitleComponent: Title,
            RecordComponent: Record
        },
        computed: {
            ...mapGetters('records', ['list', 'isShort']),
            ...mapGetters('auth', ['showShareButton']),
            ...mapFields('records', ['filters'])
        },
        mounted() {
            this.getList();
        },
        methods: {
            ...mapActions('records', ['getList', 'toggleIsShort']),

            datePickerCallback(e) {
                this.filters.createdAt = dayjs(e).format('YYYY-MM-DD');
                this.getList();
            },
            async saveCallback(viewData) {
                await sessions.setWatched(
                    process.env.VUE_APP_JOURNAL_SESSION_ID
                );
                await sessions.saveWatchedTime(viewData);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .journalHeader
    .c-form
        display: flex
        justify-content: space-between
        align-items: center

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .journalHeader
            padding-top: 15px
            flex-direction: column
</style>
